export function applyStyle(
    params,
    selectedPlaceIds,
    filteredSelectedPlaceIds,
    filteredAllPlaceIds,
    hoveredPlaceIds,
    plannablePlaceIds,
    identifier,
) {
    const placeId = params.feature.placeId;

    const isHovered = hoveredPlaceIds.includes(placeId);
    let style = null;

    if (selectedPlaceIds.includes(placeId)) {
        style = {
            strokeColor: '#cb0f0f',
            strokeOpacity: 1.0,
            strokeWeight: 1.5,
            fillColor: '#cb0f0f',
            fillOpacity: 0.5,
        };
    } else if (filteredSelectedPlaceIds?.[placeId]) {
        style = {
            strokeColor: '#cb0f0f',
            strokeOpacity: 1.0,
            strokeWeight: 1.5,
            fillColor: '#cb0f0f',
            fillOpacity: 0.5,
        };
    } else if (filteredAllPlaceIds?.[placeId]) {
        style = {
            strokeColor: '#0017a1',
            strokeOpacity: 0.6,
            strokeWeight: 1.5,
            fillColor: '#0017a1',
            fillOpacity: 0.4,
        };
    } else if (plannablePlaceIds?.[placeId]) {
        style = {
            fillColor: '#888888',
            fillOpacity: 0.5,
        };
    } else {
        return {};
    }

    return style;
}
